import { render, staticRenderFns } from "./BgqwPage12.vue?vue&type=template&id=5575deed"
import script from "./BgqwPage12.vue?vue&type=script&lang=js"
export * from "./BgqwPage12.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports